/**
 * @generated SignedSource<<2faf74459b4f527a370034271c41a2d3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PoliticalViewSelectInput_query$data = {
  readonly politicalViews: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "PoliticalViewSelectInput_query";
};
export type PoliticalViewSelectInput_query$key = {
  readonly " $data"?: PoliticalViewSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PoliticalViewSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PoliticalViewSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "PoliticalViewConnection",
      "kind": "LinkedField",
      "name": "politicalViews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PoliticalView",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "politicalViews(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "032805c426e17cb680096a5e0ba53562";

export default node;
